<template>
    <div class="mid-pane">
        <!--    Mobile left Pane-->
        <mobile-left-bar></mobile-left-bar>
        <!--    Mobile left Pane END-->

        <div class="hold">
            <!--        NavBar-->
            <div class="nav-bar">
                <div class="nav-hold">
                    <div class="back-icon" @click="backButton()">
                <span>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 31.1 31.1">
                        <path d="M30.2 16.4H0.9C0.4 16.4 0 16 0 15.5c0-0.5 0.4-0.9 0.9-0.9h29.3c0.5 0 0.9 0.4 0.9 0.9C31.1 16 30.7 16.4 30.2 16.4z" class="a"></path>
                        <path d="M16 31.1c-0.2 0-0.4-0.1-0.6-0.2L0.3 16.2C0.1 16 0 15.8 0 15.5c0-0.2 0.1-0.5 0.3-0.6L15.4 0.3c0.4-0.3 0.9-0.3 1.3 0 0.3 0.4 0.3 0.9 0 1.3L2.2 15.5l14.5 14c0.4 0.3 0.4 0.9 0 1.3C16.5 31 16.2 31.1 16 31.1z"></path>
                    </svg>
                </span>
                    </div>

                    <div class="nav-text">
                        <p class="main">Account Statement</p>
                        <p class="sub">{{getCurrentAccountForAction.accountno}}</p>
                    </div>
                </div>
            </div>
            <br>

            <!--        Intro Text-->
            <div class="card mb-4">
                <div class="card-body">
                    <div class="card-title">Time Period</div>
                    <div class="card-content">
                        <div class="alert-box">
                            <div class="row">
                                <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                                    <ui-alert @dismiss="alert.show = false" :type="alert.type" v-show="alert.show">
                                        {{alert.message}}
                                    </ui-alert>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-lg-6 col-md-6 col-sm-6 col-12 form-group">
                                <label class="form-label">Start Date</label>
                                <ui-datepicker
                                        orientation="landscape"
                                        placeholder="Select Start Date"
                                        v-model="startDate"
                                        color="accent"
                                        :max-date="new Date()"
                                        @input="datePicked($event)"
                                ></ui-datepicker>

                                <!--<input type="text" class="form-input" id="start-date" placeholder="Select Start Date">-->
                            </div>

                            <div class="col-lg-6 col-md-6 col-sm-6 col-12 form-group">
                                <label class="form-label">End Date</label>
                                <ui-datepicker
                                        orientation="landscape"
                                        placeholder="Select End Date"
                                        v-model="endDate"
                                        color="accent"
                                        :max-date="new Date()"
                                        @input="datePicked($event)"
                                ></ui-datepicker>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!--        Table-->
            <div v-show="showHistory" class="history-table">
                <div class="header">
                    <div class="row">
                        <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                            <p class="statement-header">{{getCurrentAccountForAction.accountno}} Account Statement for {{this.startDateCopy}} to {{this.endDateCopy}}</p>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6 col-6 form-group">
                            <div class="balances">
                                <p class="sup">Opening/Closing Balance</p>
                                <p class="bal">
                                    &#8358;{{totalResponse.openingbalance | moneyToDecimal}}
                                    <span class="slash">/</span>
                                    &#8358;{{totalResponse.closingbalance | moneyToDecimal}}
                                </p>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6 col-6 form-group">
                            <button @click="sendStatementToEmail()" class="btn btn-primary float-right">Send To Email</button>
                        </div>
                    </div>
                </div>

                <div class="tbl">

                    <div v-if="filteredHistory.toString() === ''">
                        <div class="empty-history">
                        <span>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
                                <circle cx="25" cy="25" r="25"></circle>
                                <line x1="25" y1="10" x2="25" y2="32" class="a"></line>
                                <line x1="25" y1="37" x2="25" y2="39" class="a"></line>
                            </svg>
                        </span>
                            <p>
                                No transaction on this account in the specified date range!
                            </p>
                        </div>
                    </div>
                    <div v-else>
                        <div v-for="record in filteredHistory" class="account-statement-group">
                            <!--<p>Skrtt!!</p>-->
                            <div v-for="(value, key) in record">
                                <span class="date">{{key | formatDateRelatively}}</span>

                                <div v-for="hist in value" class="account-statement">
                                    <article class="amount">
                                        <div v-if="hist.drcr === 'C'" class="crd"></div>
                                        <div v-if="hist.drcr === 'D'" class="dbt"></div>

                                        <!--<img :src="hist.logourl" class="history-icon" alt="">-->

                                        <span class="currency">&#8358;</span> {{hist.amount}}
                                    </article>
                                    <article class="type">{{hist.counterpartyservice | firstCaseCapitalSpace}}</article>
                                    <article class="counterparty">
                                        <p class="hist-narration" :title="hist.narration">{{hist.counterparty | firstCaseCapitalSpace}}</p>
                                    </article>
                                    <article class="icon">
                                        <a @click="openHistoryModal(hist)"><span class="fa fa-eye"></span></a>
                                    </article>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <!--UI Modal For Displaying Full Transaction Details-->
                <ui-modal
                        ref="fullHistoryModal" transition="scale-up"
                        :removeHeader= "true" size="small" @hide="fullHistoryModalHide"
                        align-top :align-top-margin="50"
                >
                    <div class="notification-modal sm">
                        <div class="head">
                            <div class="logo-hold">
                                <div>
                                    <img src="https://assets-base.s3.amazonaws.com/img/rubies/logo-sm.png" alt="" class="logo">
                                </div>
                            </div>
                        </div>

                        <div class="bottom">
                            <div class="modal-body history">
                                <div class="">
                                    <div class="trnxHist">
                                        <div class="row">
                                            <div class="col-lg-4 col-md-4 col-sm-4 col-4">
                                                <div class="logo">
                                                    <div v-if="currentFullHistory.trntype === 'AIRTIME' || currentFullHistory.trntype === 'MOBILEDATA'">
                                                        <img
                                                                v-if="currentFullHistory.counterpartybank === 'MTN'"
                                                                src="https://rubies-ibank-test-two.s3-us-west-2.amazonaws.com/img/mtn-logo.png"
                                                                alt="MTN"
                                                        >
                                                        <img
                                                                v-else-if="currentFullHistory.counterpartybank === 'AIRTEL'"
                                                                src="https://rubies-ibank-test-two.s3-us-west-2.amazonaws.com/img/airtel-logo.png"
                                                                alt="MTN"
                                                        >
                                                        <img
                                                                v-else-if="currentFullHistory.counterpartybank === 'GLO'"
                                                                src="https://rubies-ibank-test-two.s3-us-west-2.amazonaws.com/img/glo-logo.png"
                                                                alt="MTN"
                                                        >
                                                        <img
                                                                v-else-if="currentFullHistory.counterpartybank === '9MOBILE'"
                                                                src="https://rubies-ibank-test-two.s3-us-west-2.amazonaws.com/img/9mobile-logo.png"
                                                                alt="MTN"
                                                        >
                                                        <img
                                                                v-else
                                                                src="https://rubies-ibank-test-two.s3-us-west-2.amazonaws.com/img/invoice.png"
                                                                alt="NETWORK"
                                                        >
                                                    </div>
                                                    <div v-else-if="currentFullHistory.trntype === 'BILLSPAYMENT'">
                                                        <img
                                                                v-if="currentFullHistory.counterpartybank === 'MTN'"
                                                                src="https://rubies-ibank-test-two.s3-us-west-2.amazonaws.com/img/mtn-logo.png"
                                                                alt="MTN"
                                                        >
                                                        <img
                                                                v-else-if="currentFullHistory.counterpartybank === 'AIRTEL'"
                                                                src="https://rubies-ibank-test-two.s3-us-west-2.amazonaws.com/img/airtel-logo.png"
                                                                alt="MTN"
                                                        >
                                                        <img
                                                                v-else-if="currentFullHistory.counterpartybank === 'GLO'"
                                                                src="https://rubies-ibank-test-two.s3-us-west-2.amazonaws.com/img/glo-logo.png"
                                                                alt="MTN"
                                                        >
                                                        <img
                                                                v-else-if="currentFullHistory.counterpartybank === '9MOBILE'"
                                                                src="https://rubies-ibank-test-two.s3-us-west-2.amazonaws.com/img/9mobile-logo.png"
                                                                alt="MTN"
                                                        >
                                                        <img
                                                                v-else
                                                                src="https://rubies-ibank-test-two.s3-us-west-2.amazonaws.com/img/invoice.png"
                                                                alt="BILLS PAYMENT"
                                                        >
                                                    </div>
                                                    <div v-else-if="currentFullHistory.trntype === 'MONEYREQUEST'">
                                                        <img src="https://rubies-ibank-test-two.s3-us-west-2.amazonaws.com/img/money-request.png" class="alt" alt="">
                                                    </div>
                                                    <div v-else-if="currentFullHistory.trntype === 'OUTWARD' || currentFullHistory.trntype === 'TRANSFER'">
                                                        <img :src="currentFullHistory.logourl" alt="">
                                                    </div>
                                                    <div v-else>
                                                        <img src="https://rubies-ibank-test-two.s3-us-west-2.amazonaws.com/img/invoice.png" class="alt" alt="">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-lg-8 col-md-8 col-sm-8 col-8 text-right">
                                                <div class="amount">
                                                    <div class="crdDbt">
                                                        <span v-if="currentFullHistory.drcr === 'C'" class="crd"></span>
                                                        <span v-else="currentFullHistory.drcr === 'D'" class="dbt"></span>
                                                    </div>

                                                    <p v-if="currentFullHistory.amount">
                                                        <span class="currency">₦</span>
                                                        {{currentFullHistory.amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    <div class="trnxHist">
                                        <div class="row">
                                            <div class="col-lg-4 col-md-4 col-sm-4 col-4">
                                                <p class="histLabel">Account</p>
                                            </div>
                                            <div class="col-lg-8 col-md-8 col-sm-8 col-8 text-right">
                                                <p class="histRecord">{{currentFullHistory.accountname}} ({{currentFullHistory.account}})</p>
                                            </div>
                                        </div>
                                    </div>

                                    <hr>

                                    <div class="trnxHist">
                                        <div class="row">
                                            <div class="col-lg-4 col-md-4 col-sm-4 col-4">
                                                <p class="histLabel">Counterparty</p>
                                            </div>
                                            <div class="col-lg-8 col-md-8 col-sm-8 col-8 text-right">
                                                <p class="histRecord">
                                                    {{currentFullHistory.counterparty}}
                                                    <span v-if="currentFullHistory.counterpartyaccount">
                                                    ({{currentFullHistory.counterpartyaccount}})
                                                </span>
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    <hr>

                                    <div class="trnxHist">
                                        <div class="row">
                                            <div class="col-lg-4 col-md-4 col-sm-4 col-4">
                                                <p class="histLabel">Date</p>
                                            </div>
                                            <div class="col-lg-8 col-md-8 col-sm-8 col-8 text-right">
                                                <p class="histRecord">{{currentFullHistory.eventdate}}</p>
                                            </div>
                                        </div>
                                    </div>

                                    <hr >

                                    <div class="trnxHist">
                                        <div class="row">
                                            <div class="col-lg-4 col-md-4 col-sm-4 col-4">
                                                <p class="histLabel">Type</p>
                                            </div>
                                            <div class="col-lg-8 col-md-8 col-sm-8 col-8 text-right">
                                                <p class="histRecord">{{currentFullHistory.trntype}}</p>
                                            </div>
                                        </div>
                                    </div>

                                    <hr >

                                    <div class="trnxHist">
                                        <div class="row">
                                            <div class="col-lg-4 col-md-4 col-sm-4 col-4">
                                                <p class="histLabel">Channel/Service</p>
                                            </div>
                                            <div class="col-lg-8 col-md-8 col-sm-8 col-8 text-right">
                                                <p class="histRecord">{{currentFullHistory.counterpartychannel}}/{{currentFullHistory.counterpartyservice}}</p>
                                            </div>
                                        </div>
                                    </div>

                                    <hr >

                                    <div class="trnxHist">
                                        <div class="row">
                                            <div class="col-lg-4 col-md-4 col-sm-4 col-4">
                                                <p class="histLabel">Ref</p>
                                            </div>
                                            <div class="col-lg-8 col-md-8 col-sm-8 col-8 text-right">
                                                <p class="histRecord">{{currentFullHistory.contractref}}</p>
                                            </div>
                                        </div>
                                    </div>

                                    <hr >

                                    <div class="trnxHist">
                                        <div class="row">
                                            <div class="col-lg-4 col-md-4 col-sm-4 col-4">
                                                <p class="histLabel">Narration</p>
                                            </div>
                                            <div class="col-lg-8 col-md-8 col-sm-8 col-8 text-right">
                                                <p class="histRecord">{{currentFullHistory.narration}}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-button">
                                <button @click="closeModal('fullHistoryModal')" class="btn btn-primary btn-xnax-login ">Ok</button>
                            </div>
                        </div>
                    </div>
                </ui-modal>



                <!--UI Modal For Displaying Transfer Success Message-->
                <ui-modal
                        ref="transferSuccessModal" transition="scale-up"
                        :removeHeader= "true" size="small" @hide="closeResponseModal"
                        align-top :align-top-margin="200"
                >
                    <div class="notification-modal sm">
                        <div class="head">
                            <div class="logo-hold">
                                <div>
                                    <img src="https://assets-base.s3.amazonaws.com/img/rubies/logo-sm.png" alt="" class="logo">
                                </div>
                            </div>
                        </div>

                        <div class="bottom">
                            <div class="modal-body">
                                <div class="row">
                                    <div class="col-2">
                                        <div class="left">
                                            <div class="status-icon">
                                                <svg class="success" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 496.2 496.2">
                                                    <path d="M496.2 248.1c0-137-111.1-248.1-248.1-248.1C111.1 0 0 111.1 0 248.1c0 137 111.1 248.1 248.1 248.1C385.1 496.2 496.2 385.1 496.2 248.1z"></path>
                                                    <path d="M384.7 165c-5.8-15.1-17.7-12.7-30.6-10.1 -7.7 1.6-42 11.6-96.1 68.8 -22.5 23.7-37.3 42.6-47.1 57 -6-7.3-12.8-15.2-20-22.3 -22.1-22.1-46.7-37.2-47.7-37.9 -10.3-6.3-23.8-3.1-30.2 7.3 -6.3 10.3-3.1 23.8 7.2 30.2 0.2 0.1 21.4 13.2 39.6 31.5 18.6 18.6 35.5 43.8 35.7 44.1 4.1 6.2 11 9.8 18.3 9.8 1.2 0 2.5-0.1 3.8-0.3 8.6-1.5 15.4-7.9 17.5-16.3 0.1-0.2 8.8-24.3 54.7-72.7 37-39.1 61.7-51.5 70.3-54.9 0.1 0 0.1 0 0.3 0 0 0 0.3-0.1 0.8-0.4 1.5-0.6 2.3-0.8 2.3-0.8 -0.4 0.1-0.6 0.1-0.6 0.1l0-0.1c4-1.7 11.4-4.9 11.5-5C385.4 188.2 389 176.2 384.7 165z" fill="#FFF"></path>
                                                </svg>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-10 pl-2">
                                        <div class="right">
                                            <p>
                                                {{successMessage}}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-button">
                                <button @click="closeModal('transferSuccessModal')" class="btn btn-primary btn-xnax-login ">Ok</button>
                            </div>
                        </div>
                    </div>
                </ui-modal>

                <!--UI Modal For Displaying Transfer Failed Message-->
                <ui-modal
                        ref="transferFailModal" transition="scale-up"
                        :removeHeader= "true" size="small" @hide="closeResponseModal"
                        align-top :align-top-margin="200"
                >
                    <div class="notification-modal sm">
                        <div class="head">
                            <div class="logo-hold">
                                <div>
                                    <img src="https://assets-base.s3.amazonaws.com/img/rubies/logo-sm.png" alt="" class="logo">
                                </div>
                            </div>
                        </div>

                        <div class="bottom">
                            <div class="modal-body">
                                <div class="row">
                                    <div class="col-2">
                                        <div class="left">
                                            <div class="status-icon">
                                                <!--<svg class="error" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 455.1 455.1">-->
                                                <!--<circle cx="227.6" cy="227.6" r="227.6" fill="#E24C4B"></circle>-->
                                                <!--<path d="M455.1 227.6c0 125.2-102.4 227.6-227.6 227.6 -72.5 0-136.5-32.7-177.8-85.3 38.4 31.3 88.2 49.8 142.2 49.8 125.2 0 227.6-102.4 227.6-227.6 0-54-18.5-103.8-49.8-142.2C422.4 91 455.1 155 455.1 227.6z" fill="#D1403F"></path>-->
                                                <!--<path d="M331.4 331.4c-8.5 8.5-22.8 8.5-31.3 0l-72.5-72.5 -72.5 72.5c-8.5 8.5-22.8 8.5-31.3 0 -8.5-8.5-8.5-22.8 0-31.3l72.5-72.5 -72.5-72.5c-8.5-8.5-8.5-22.8 0-31.3 8.5-8.5 22.8-8.5 31.3 0l72.5 72.5 72.5-72.5c8.5-8.5 22.8-8.5 31.3 0 8.5 8.5 8.5 22.8 0 31.3l-72.5 72.5 72.5 72.5C339.9 308.6 339.9 322.8 331.4 331.4z" fill="#FFF"></path>-->
                                                <!--</svg>-->
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
                                                    <circle cx="25" cy="25" r="25" fill="#D75A4A"></circle>
                                                    <polyline points="16 34 25 25 34 16 " class="svgA"></polyline>
                                                    <polyline points="16 16 25 25 34 34 " class="svgA"></polyline>
                                                </svg>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-10 pl-2">
                                        <div class="right">
                                            <p>
                                                Failed!! <br>
                                                {{errorMessage}}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-button">
                                <button @click="closeModal('transferFailModal')" class="btn btn-primary btn-xnax-login ">Ok</button>
                            </div>
                        </div>
                    </div>
                </ui-modal>
            </div>

            <footer-mobile></footer-mobile>
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import moment from 'moment'
    import MobileLeftBar from '../sidebar/MobileLeftBar'
    import FooterMobile from "../utility/FooterMobile";


    export default {
        name: "RequestStatement",
        components: {
            FooterMobile,
            mobileLeftBar: MobileLeftBar,
        },
        props: { },
        data () {
            return {
                startDate: null,
                startDateCopy: '',
                endDate: null,
                endDateCopy: '',

                originalHistory: [],
                filteredHistory: [],
                totalResponse: {},
                showHistory: false,

                currentFullHistory: [],

                successMessage: '',
                errorMessage: '',
                alert: {
                    show: false,
                    type: 'error',
                    message: 'Something Went Wrong!'
                },
            }
        },
        computed: {
            ...mapGetters([
                'getSideBarPage',
                'getInsideCurrentPage',
                'getDataOnLogin',
                'getCurrentAccountForAction',
            ])
        },
        created () {},
        methods: {
            ...mapActions([
                'updateAppLoading',
                'updateSideBarPage',
                'updateInsideCurrentPage',
                'updateFullBankList',
            ]),

            backButton(){
                this.updateInsideCurrentPage('accountStatement');
                this.updateSideBarPage('account-statement');
            },
            showAlert(show, type, message){
                this.alert.show = show;
                this.alert.type = type;
                this.alert.message = message;
            },
            openModal(ref) {
                this.$refs[ref].open();
            },
            closeModal(ref) {
                this.$refs[ref].close();
            },

            datePicked(_event){
                if (this.startDate === null || this.endDate === null) { }
                else {
                    this.fetchStatement()
                }
            },

            fetchStatement(){
                //start app running
                this.updateAppLoading(true);

                //    prepare the post Body
                let bodyToSend ={
                    accountnumber:  this.getCurrentAccountForAction.accountno,
                    startdate: moment(String(this.startDate)).format('DD-MMM-YYYY'),
                    enddate: moment(String(this.endDate)).format('DD-MMM-YYYY'),
                    email: this.getDataOnLogin.email,
                }


                let bodyToSendStrigified = JSON.stringify(bodyToSend);

                // console.log('Stringified Body ==>>', bodyToSendStrigified)


                // keep the start and end date somewhere for dispaying and UX
                this.startDateCopy = moment(String(this.startDate)).format('DD-MMM-YYYY');
                this.endDateCopy = moment(String(this.endDate)).format('DD-MMM-YYYY');

                //Reset the start and end date to null to prevent app from crashing
                this.startDate = null
                this.endDate = null

                axios
                    .post('/accountstatement',
                        bodyToSend,
                        {
                            headers : {
                                'Authorization': this.getDataOnLogin.authorization,
                                'Content-Type': 'application/json',
                                'Access-Control-Allow-Origin': '*'
                            }})
                    .then(response => {
                        //stop app running
                        this.updateAppLoading(false);

                        let responseData =  response.data

                        if (responseData.responsecode === '00') {
                            this.originalHistory = responseData.transactionlist

                            this.totalResponse = responseData

                            // filter the account history received
                            this.filterTheHistory(this.getCurrentAccountForAction.accountno)

                        } else {
                            // display error notification
                            this.showAlert(true, 'error', responseData.responsemessage)
                        }
                    })
                    .catch(error => {
                        //stop app running
                        this.updateAppLoading(false);


                        // clear form inputs
                        // console.log(error);

                        // display error notification
                        this.showAlert(true, 'error', 'Network Error')
                    })
            },

            filterTheHistory(_accountNo){

                let curDate = '';
                let txtCount = 0;
                let objOuter = {};
                let arrInner = [];

                let filtered = [];
            // .sort(function(a, b) {
            //         let dateA = new Date(a.eventdate), dateB = new Date(b.eventdate);
            //         return dateA - dateB;
            //     });
                this.originalHistory = this.originalHistory.sort(function(a, b) {
                    let dateA = new Date(a.txndate), dateB = new Date(b.txndate);
                    return dateB - dateA;
                });

                for (let i = 0; i < this.originalHistory.length; i++) {

                    if (txtCount <= (this.originalHistory.length -1)){
                        if (this.originalHistory[i].account === _accountNo) {
                            if (curDate === ''){ curDate = this.originalHistory[i].txndate;}

                            if (curDate === this.originalHistory[i].txndate){

                                arrInner.push(this.originalHistory[i]);
                                txtCount = txtCount+1


                                if (txtCount === this.originalHistory.length){
                                    objOuter[curDate] = arrInner;
                                    filtered.push(objOuter);
                                }

                            } else {
                                if (arrInner){
                                    objOuter[curDate] = arrInner;
                                }


                                filtered.push(objOuter);

                                arrInner = [];
                                objOuter = {};
                                curDate = this.originalHistory[i].txndate;
                                arrInner.push(this.originalHistory[i]);
                                txtCount = txtCount+1
                            }
                        }
                    }
                    // }
                }

                this.filteredHistory = filtered

                this.showHistory = true;

            },


            //    History
            openHistoryModal(_hist){
                // console.log('History ==>>', _hist);

                this.currentFullHistory = _hist

                //Show Success Modal and then redirect to the home page / login page
                this.openModal('fullHistoryModal');
            },
            fullHistoryModalHide(){
                // change the currentComponent in the store to 'dashboard'
                // console.log('History Modal Close')
            },

            sendStatementToEmail(){
                //start app running
                this.updateAppLoading(true);

                //    prepare the post Body
                let bodyToSend ={
                    closingbalance:  this.totalResponse.closingbalance,
                    enddate:  this.endDateCopy,
                    openingbalance:  this.totalResponse.openingbalance,
                    startdate:  this.startDateCopy,
                    accountnumber:  this.getCurrentAccountForAction.accountno,
                    accountname:  this.getCurrentAccountForAction.accountname,
                    accounttype:  this.getCurrentAccountForAction.account_type,
                    email:  this.getDataOnLogin.email,
                    transactionlist: this.originalHistory,
                    account:  this.getCurrentAccountForAction.accountno,
                }


                // console.log('Body To Send ==>>', bodyToSend)

                axios
                    .post('/sendpdfstatementtomail', bodyToSend,
                        {
                            headers : {
                                'Authorization': this.getDataOnLogin.authorization,
                                'Content-Type': 'application/json',
                                'Access-Control-Allow-Origin': '*'
                            }})
                    .then(response => {
                        //stop app running
                        this.updateAppLoading(false);

                        let responseData =  response.data

                        // console.log('Response', responseData)

                        if (responseData.responsecode === '00') {
                            this.successMessage = responseData.responsemessage

                            this.openResponseSuccessModal();

                        } else {
                            this.errorMessage = responseData.responsemessage


                            // display error notification
                            this.openResponseFailModal();
                        }
                    })
                    .catch(error => {
                        //stop app running
                        this.updateAppLoading(false);

                        // log Error
                        // console.log(error);

                        this.errorMessage = 'Network Error'

                        // display error notification
                        this.openResponseFailModal();
                    })
            },

            openResponseSuccessModal(){
                //Open The TransferSuccessModal
                this.openModal('transferSuccessModal');
            },
            closeResponseSuccessModal(){
                //Close the TransferSuccessModal
                this.closeModal('transferSuccessModal')
            },
            openResponseFailModal(){
                //Open The TransferSuccessModal
                this.openModal('transferFailModal');
            },
            closeResponseFailModal(){
                //Close the TransferSuccessModal
                this.closeModal('transferFailModal')
            },
            closeResponseModal(){
                // console.log('Response Modal Hide')
                //Update the current sub component in the store

            },
        },
        mounted(){
            this.$nextTick(()=>{});
        },
    }
</script>

<style scoped>
.account-statement-group span.date {
    margin-left: 5px;
}
.history-table .header{
    margin-top: 30px;
}
.history-table .header .statement-header{
    font-weight: 400;
    padding: 5px 0 0 5px;
    margin-bottom: 5px;
    font-size: 14px;
    color: #606161;
}
.history-table .header .balances{}
.history-table .header .balances .sup{
    font-size: 9px;
    line-height: 9px;
    margin-bottom: 2px;
    font-weight: 500;
    color: #acacac;
    padding: 0 0 0 5px;
}
.history-table .header .balances .bal{
    font-size: 12px;
    line-height: 12px;
    margin-bottom: 0;
    padding: 0 0 0 5px;
    text-transform: uppercase;
    font-weight: 400;
    color: #616161;
}
.history-table .header .balances .bal .slash{
    color: #6d0606;
}
.history-table .header button{
    margin-top: -15px;
    border-color: #6d0606;
    color: #6d0606;
}
</style>
